import React from 'react'

import RefreshAlert from '../../components/atoms/RefreshAlert'

import { track } from '@SonarCX/lib/mixpanel'

const FIFTEEN_MINUTES = 900000
const TWO_HOURS = 720000000

const getFile = async (url: string): Promise<string> => {
  try {
    // Get file, either local or upstream
    const file = await fetch(url)

    // Make sure the file exists, if it doesn't then the index.html is returned by default from the server
    const type = file.headers.get('content-type')
    if (!type.startsWith('text/plain')) {
      return ''
    }

    const text = await file.text()
    return text
  } catch (err) {
    console.error(`Error fetching ${url}`, err)
    return ''
  }
}

interface UpstreamUpdateProviderProps {
  children?: React.ReactNode | React.ReactNode[]
}

const UpstreamUpdateProvider: React.FC<UpstreamUpdateProviderProps> = ({
  children
}) => {
  const [show, setShow] = React.useState(false)
  const [snoozed, setSnoozed] = React.useState(false)

  //If user closes, then prompt again
  const OnCloseClick = React.useCallback(() => {
    setShow(false)
    setSnoozed(true)
    setTimeout(() => {
      track('UPDATE_PROMPT_SHOW')
      setShow(true)
    }, TWO_HOURS)
    track('UPDATE_PROMPT_SNOOZE')
  }, [])

  // Fetch local and upstream versions every 15 minutes
  React.useEffect(() => {
    const interval = setInterval(() => {
      ;(async () => {
        try {
          let version = localStorage.getItem('version')
          if (!version) {
            const local = await getFile('/version.txt')
            localStorage.setItem('version', local)
            version = local
          }
          const upstream = await getFile(`${window.origin}/version.txt`)
          if (!snoozed) {
            const shouldShow = version !== upstream
            if (shouldShow) {
              track('UPDATE_PROMPT_SHOW')
            }
            setShow(shouldShow)
          }
        } catch (err) {
          console.error('Error fetching versions', err)
        }
      })()
    }, FIFTEEN_MINUTES)
    return () => clearInterval(interval)
  }, [snoozed])

  return (
    <React.Fragment>
      {children}

      {show && <RefreshAlert onClose={OnCloseClick} />}
    </React.Fragment>
  )
}

export default UpstreamUpdateProvider
